export const LAST_NAME_MAX_LENGTH = 30;
